import { Category } from "./category";

export abstract class CategoryRepository {
  getAllCategoris: () => Promise<Array<Category>>;
}
